// extracted by mini-css-extract-plugin
module.exports = {"root":"Piano_root__3xAlc","row":"Piano_row__-HfP7","col":"Piano_col__tDafi"};